import { render, staticRenderFns } from "./VimeoUpload.vue?vue&type=template&id=b39f6f1e&"
import script from "./VimeoUpload.vue?vue&type=script&lang=js&"
export * from "./VimeoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports